<template>
  <div class="talent-container">
    <div class="banner-container">
      <img
        src="../../../assets/images/talent/banner.jpg"
      />
    </div>
    <p class="section-title-line">
      <span>人才理念</span>
    </p>
    <div class="section-container intro-box-content">
      <p>在新希望，我们视人才为最宝贵的资产和企业成功的关键。</p>
      <p>我们欣赏员工的多元化背景，</p>
      <p>鼓励团队协作，同时亦珍视个人才华。</p>
      <p>只因我们深信，</p>
      <p>卓尔不凡的企业和出类拔萃的人才如同天造地设，</p>
      <p>骨子里与生俱来拥有引领潮流的志向。</p>
    </div>

    <p class="section-title-line">
      <span>我们最珍视的人才素质</span>
    </p>

    <div class="section-container">
      <el-row class="talent-item wow animate__slideInUp" data-wow-duration="500ms">
        <el-col :span="12">
          <div class="text-box">
            <p class="text-ch">团队精神</p>
            <p class="text-en">Teamwork</p>
            <p class="text-info">我们重视团队精神，</p>
            <p class="text-info">深信一支积极进取、多元共融的团队，</p>
            <p class="text-info">是组织保持创造力和取得持续成功的关键。</p>
          </div>
        </el-col>
        <el-col :span="12">
          <img
            style="width: 100%"
            src="../../../assets/images/talent/1.jpg"
            alt=""
          />
        </el-col>
      </el-row>
      <el-row class="talent-item wow animate__slideInUp" data-wow-duration="500ms">
        <el-col :span="12">
          <div class="text-box">
            <p class="text-ch">终身学习</p>
            <p class="text-en">Lifelong Learning</p>
            <p class="text-info">在新希望，终身学习是我们一以贯之的人才理念。</p>
            <p class="text-info">保持好奇心和求知欲，</p>
            <p class="text-info">是我们保持创造力的根本源泉。</p>
          </div>
        </el-col>
        <el-col :span="12">
          <img
            style="width: 100%"
            src="../../../assets/images/talent/2.jpg"
            alt=""
          />
        </el-col>
      </el-row>
      <el-row class="talent-item wow animate__slideInUp" data-wow-duration="500ms">
        <el-col :span="12">
          <div class="text-box">
            <p class="text-ch">领导力</p>
            <p class="text-en">Leadership</p>
            <p class="text-info">领导力既是科学也是艺术。</p>
            <p class="text-info">它驱动组织创新变革，帮助个体自我提升。</p>
            <p class="text-info">杰出领导力让我们保持持续领先的优势。</p>
          </div>
        </el-col>
        <el-col :span="12">
          <img
            style="width: 100%"
            src="../../../assets/images/talent/3.jpg"
            alt=""
          />
        </el-col>
      </el-row>
      <el-row class="talent-item wow animate__slideInUp" data-wow-duration="500ms">
        <el-col :span="12">
          <div class="text-box">
            <p class="text-ch">追求卓越</p>
            <p class="text-en">Pursuing Excellence</p>
            <p class="text-info">格局决定结局，态度决定高度。</p>
            <p class="text-info">专注投入、追求卓越，这是我们团队独特的竞争优势。</p>
          </div>
        </el-col>
        <el-col :span="12">
          <img
            style="width: 100%"
            src="../../../assets/images/talent/4.jpg"
            alt=""
          />
        </el-col>
      </el-row>
      <el-row class="talent-item wow animate__slideInUp" data-wow-duration="500ms">
        <el-col :span="12">
          <div class="text-box">
            <p class="text-ch">开放和包容</p>
            <p class="text-en">Open and Inclusive</p>
            <p class="text-info">多元化的人才结构造就了我们独特的团队气质。</p>
            <p class="text-info">我们鼓励员工保持开放和包容的心态，</p>
            <p>以吸纳新知，增进智慧，提升竞争力。</p>
          </div>
        </el-col>
        <el-col :span="12">
          <img
            style="width: 100%"
            src="../../../assets/images/talent/5.jpg"
            alt=""
          />
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  name: "TalentPage",
  mounted() {
    this.$nextTick(() => {
      this.$wow.init();
    })
  }
};
</script>
<style lang="scss" scoped>
.talent-container {
  .talent-item {
    box-sizing: border-box;
    padding: 50px 0;
    border-bottom: 1px solid #3b4850;

    &:first-child {
      padding-top: 0;
    }
  }
  .text-box {
    color: #565c61;
  }

  .text-ch {
    font-size: 28px;
  }

  .text-en {
    font-size: 27px;
    margin-bottom: 30px;
  }

  .text-info {
    font-size: 13px;
    line-height: 25px;
  }
}
</style>
